module.exports = "/_next/static/images/pro-contact-c9d9cc655882c9bc043a4fb8c8f6cbf6.svg";